import { faSquarePen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from 'i18next'
import moment from 'moment'
import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  ROUTES,
  pendingStatusDocument,
  processStatusSalesOrder,
  closeStatusDocument,
  expiredStatusDocument,
  colorsStatus,
} from 'Utils/constants'
import { FormatMoney, generateColorStatus } from 'Utils/functions'

export function useColumnSearchSaleOrderWeb() {
  const [dispatchPopover, setDispatchPopover] = useState({
    openPopover: false,
    anchorEl: null,
    value: [],
  })

  const columns = useMemo(
    () => [
      {
        accessor: 'CustomerNameDocument',
        Header: t('SEARCH_QUOTATION_T.CLIENT_NAME'),
        width: '220px',
        Cell: ({ row }) =>
          row.original.CustomerNameDocument ||
          row.original.CustomerFullName ||
          t('UNKNOWN'),
      },
      {
        accessor: 'WarehouseDescription',
        Header: t('SEARCH_QUOTATION_T.WAREHOUSE_LABEL'),
        width: '170px',
        Cell: ({ row }) => row.original.WarehouseDescription || t('UNKNOWN'),
      },
      {
        accessor: 'DocumentNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_SALE_ORDER_LABEL'),
        width: '190px',
      },
      {
        accessor: 'QuoteNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL'),
        width: '185px',
        Cell: ({ row }) => row.original.QuoteNumber || t('UNKNOWN'),
      },
      {
        accessor: 'DispatchNumbers',
        Header: t('SEARCH_QUOTATION_T.NUMBER_DESPACHO_LABEL'),
        width: '160px',
        Cell: ({ row }) => {
          const dispatches = row.original.DispatchNumbers
            ? row.original.DispatchNumbers.split(',')
            : []

          if (!dispatches.length) return t('UNKNOWN')

          return (
            <div className="sd-number-container">
              <span>{dispatches[0]}</span>
              {dispatches.length > 1 && (
                <a
                  href="#"
                  onClick={event => {
                    event.preventDefault()
                    setDispatchPopover({
                      value: dispatches,
                      anchorEl: event.currentTarget,
                      openPopover: true,
                    })
                  }}>
                  +{dispatches.length - 1}
                </a>
              )}
            </div>
          )
        },
      },
      {
        accessor: 'AmountWithTax',
        Header: t('SEARCH_QUOTATION_T.QUOTATION_AMOUNT_LABEL'),
        width: '120px',
        Cell: ({ row }) =>
          `$ ${FormatMoney(row.original.AmountWithTax || 0, false, 2, true)}`,
      },
      {
        accessor: 'CreatedDate',
        Header: t('SEARCH_QUOTATION_T.DATE_QUOTATION_LABEL'),
        width: '110px',
        Cell: ({ row }) =>
          moment(row.original.CreatedDate).format('DD/MM/YYYY'),
      },
      {
        accessor: 'DocHeaderStatusDescription',
        Header: t('SEARCH_QUOTATION_T.STATUS_LABEL'),
        width: '150px',
        Cell: ({ row }) => {
          const status = row.original.DocHeaderStatusDescription
          return (
            <span
              style={{
                backgroundColor: generateColorStatus(
                  status,
                  pendingStatusDocument,
                  processStatusSalesOrder,
                  closeStatusDocument,
                  expiredStatusDocument,
                  colorsStatus
                ),
                borderRadius: '5px',
                padding: '2px 8px',
                display: 'inline-block',
              }}>
              {status}
            </span>
          )
        },
      },
      {
        accessor: 'actions',
        Header: t('ACTION_TABLE_T.ACTIONS_LABEL'),
        width: '80px',
        Cell: ({ row }) => (
          <Link
            to={`${ROUTES.salesOrder}${row.original.DocHeaderId}`}
            data-testid="icon-edit"
            aria-label="Ver orden de venta">
            <FontAwesomeIcon
              icon={faSquarePen}
              style={{ color: '#3FC5DF', fontSize: '2rem' }}
            />
          </Link>
        ),
      },
    ],
    []
  )

  return { columns, dispatchPopover, setDispatchPopover }
}
